module.exports = __webpack_public_path__ + "img/daily-calendar-svgrepo-com.ac5ffe99.svg";